<template>
    <div class="login">
        <div class="login_main">
            <img class="login_main_left" src="../assets/images/pic.png" alt="">
            <div class="login_content">
                <img class="login_title" src="../assets/images/logo_title.png" alt="">
                <div class="login_form">
                    <div class="login_name login_input">
                        <img class="login_icon" src="../assets/images/user_4_fill.png" alt="">
                        <input v-model="formData.username" placeholder="请输入账号" type="text">
                    </div>
                    <div class="login_password login_input">
                        <img class="login_icon" src="../assets/images/lock_fill.png" alt="">
                        <input v-model="formData.password" show-password :type="passwordText" placeholder="请输入密码">
                        <img v-if="passwordText=='password'" @click="changePassword('text')" class="login_eye"
                             src="../assets/images/eye_close_line.png" alt="">
                        <img v-if="passwordText=='text'" @click="changePassword('password')" class="login_eye"
                             src="../assets/images/eye_open_line.png" alt="">
                    </div>
                    <div class="login_btn" @click="login">
                        确定
                    </div>
                </div>
                <div class="login_operate" style="display:none">
                    <div class="login_operate_left">
                        <el-checkbox label="" v-model="checkboxValue">记住密码</el-checkbox>
                    </div>

                    <div class="login_operate_right">
                        忘记密码
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {ref, onMounted, reactive, getCurrentInstance} from 'vue'
    import {useRouter} from 'vue-router';
    import axios from 'axios'
    import {ElMessageBox} from 'element-plus';
    import {useStore} from 'vuex'

    export default {
        name: "Login",
        setup() {
            const router = useRouter();
            const store = useStore();
            const {proxy} = getCurrentInstance();
            let passwordText = ref("password");

            const changePassword = (param) => {
                passwordText.value = param;
            }
            let checkboxValue = ref(false)
            const formData = reactive({
                username: "",
                password: "",
            })
            const formdataify = (params) => {
                const formData = new FormData();
                Object.keys(params).forEach(key => {
                    if (typeof params[key] == "string") {
                        formData.append(key, params[key]);
                    } else {
                        formData.append(key, JSON.stringify(params[key]));
                    }
                });
                return formData;
            };
            const login = () => {
                if (formData.username && formData.password) {
                    var s4 = SoftEncryption.loginSM2Encry(formData.username, formData.password, unescape(_secretKey.value));
                    proxy.$axios.post("/jgfast/login", formdataify({
                        username: s4.username,
                        password: s4.password,
                        rememberMe: false,
                        kg4: s4.kg4,
                        sign: s4.sign
                    })).then((res) => {
                        if (res.code == "00000") {
                            // axios.defaults.headers.common["token"] = res.sId;
                            localStorage.setItem('user_token', res.token)
                            console.log(res,res.token)
                            store.state.token = res.token
                            router.push({
                                path: "/index",
                            })
                            store.state.leftTreeToHeaderTab=[{
                                name: "Home",//组件的名称
                                label: "首页",//组件在头部显示的tab名字
                                linkTo: "/Home",//目前无作用
                                query:null,//传递给组件的值
                            }]
                            store.state.headerActiveTab=store.state.leftTreeToHeaderTab[0].label;
                        } else {
                            ElMessageBox({
                                    title: '提示',
                                    message: res.msg,
                                    showCancelButton: false,
                                    confirmButtonText: '确认',
                                }
                            )
                        }
                    });
                }

            }
            const fastSessionId = ref();
            const _secretKey = ref();
            onMounted(() => {
                proxy.$axios.get("/jgfast/getSessionIdAndSecretKey").then((res) => {
                    console.log(res)
                    fastSessionId.value = res["token"];
                    _secretKey.value = res._secretKey;
                    axios.defaults.headers.common["__ajax"] = "json";
                    document.cookie = "fast.session.id=" + fastSessionId.value + "; _secretKey=" + _secretKey.value
                });
            })
            return {
                login,
                passwordText,
                changePassword,
                checkboxValue,
                formData,
            }
        }
    }
</script>

<style scoped>

</style>
